<app-form-page [config]="config" [dialogRef]="dialogRef"></app-form-page>
